import React from 'react';
import { getFieldValue, getAssetUrl, extractRichTextFromFields, renderRichText } from '../../../contentful/mappers';
import './SplitCard.css';

function SplitCard({ data }) {
  if (!data) return null;

  const headline = getFieldValue(data, 'headline');
  const bgTheme = getFieldValue(data, 'bgTheme') || 'light';
  const imagePercentage = getFieldValue(data, 'imagePercentage') || '50%';
  const imageSide = getFieldValue(data, 'imageSide') || 'Right';

  // Get text with robust locale handling
  const text = extractRichTextFromFields(data, 'text');

  const sectionClass = `split-card-section split-card-section-${bgTheme}`;
  const isImageLeft = imageSide.toLowerCase() === 'left';

  // Get image directly from data.fields to avoid getFieldValue transformation
  let imageUrl = null;
  if (data && data.fields && data.fields.image) {
    const imageField = data.fields.image;
    
    // Check if it's a locale object
    if (typeof imageField === 'object' && imageField !== null && !Array.isArray(imageField)) {
      // Check if it has 'en-US' key
      if (imageField['en-US'] && imageField['en-US'].fields) {
        imageUrl = getAssetUrl(imageField['en-US']);
      } 
      // Check if it's already the asset object
      else if (imageField.fields && imageField.fields.file) {
        imageUrl = getAssetUrl(imageField);
      }
      // Otherwise, try to find a locale key that has fields
      else {
        const localeKeys = Object.keys(imageField).filter(key => {
          const value = imageField[key];
          return value && typeof value === 'object' && value.fields && value.fields.file;
        });
        if (localeKeys.length > 0) {
          imageUrl = getAssetUrl(imageField[localeKeys[0]]);
        }
      }
    } 
    // If it's already the asset object directly
    else if (imageField && imageField.fields && imageField.fields.file) {
      imageUrl = getAssetUrl(imageField);
    }
  }

  // Parse imagePercentage to ensure it's a valid CSS value
  const imagePercentageValue = `${imagePercentage * 100}%`;

  return (
    <section className={sectionClass}>
      <div className="container">
        <div className={`split-card-content ${isImageLeft ? 'image-left' : 'image-right'}`}>
          {isImageLeft && imageUrl && (
            <div 
              className="split-card-image-wrapper"
              style={{ width: imagePercentageValue }}
            >
              <img 
                src={imageUrl} 
                alt={headline || 'Split card image'} 
                className="split-card-image"
              />
            </div>
          )}
          <div className="split-card-text">
            {headline && <h2 className="split-card-headline">{headline}</h2>}
            {text && (
              <div className="split-card-text-content">
                {renderRichText(text)}
              </div>
            )}
          </div>
          {!isImageLeft && imageUrl && (
            <div 
              className="split-card-image-wrapper"
              style={{ width: imagePercentageValue }}
            >
              <img 
                src={imageUrl} 
                alt={headline || 'Split card image'} 
                className="split-card-image"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default SplitCard;
